import { StyleRules, makeStyles, createStyles } from "@material-ui/core";
import { RelodeTheme } from "..";

export const InputStyles: StyleRules = {
    inputRoot: {
        margin: 0,
    },
};

export const useInputCommonStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            inputRoot: {
                margin: 0,
            },
            innerInput: {
                paddingBottom: 5,
            },
            wrappedInput: {
                flexWrap: "wrap",
            },
        }),
    { name: "InputCommonStyles" }
);
